<input #search [ngStyle]="{'height': height ? height + 'px' : 'auto'}"
       [placeholder]="inputAddress ? inputAddress : ''"
       [disabled]="isEnable"
       class="form-control"
       fullWidth nbInput
       required shape="rectangle" status="primary" type="text">
